import React from 'react';

{/* tslint:disable */}
const SVG = ({width = '2.4em', height = '2.4em', color = '#000'}) =>
  <svg
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 50 50"
    style={{ fill: color || '#000' }}
    xmlns="http://www.w3.org/2000/svg">
      <g id="surface1">
        <path d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z "/>
      </g>
  </svg>;

export default SVG;
